// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2d40735f","952":"6b4f8c73"}[chunkId] + ".chunk.js";
};